<!--
File: cc-cell-item-model-selector.component.html
Project: catalog-cloud
File Created: Wednesday, 2nd March 2022 09:47:48
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Monday, 18th November 2024 4:04:52 pm
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->
<p-button
  class="n-button-icon"
  icon="fa fa-ellipsis-vertical"
  size="small"
  severity="info"
  (onClick)="productModel.toggle($event)"
  aria-label="Model type product"
  styleClass="n-button-icon-xs"
  [pTooltip]="'Model type selector'"
  [tooltipPosition]="'top'"

>
</p-button>

<p-menu #productModel [popup]="true" appendTo="body">
  <button
    mat-menu-item
    *ngFor="let item of formatedModels"
    (click)="changeModel(item)"
  >
    <i *ngIf="item == modelSelected" color="primary">checked</i> {{ item }}
  </button>
</p-menu>
<!--
<div appearance="fill" style="width: 100%;"  >
  <mat-select  [(value)]="modelSelected" (selectionChange)="changeModel($event.value)">
    <mat-option *ngFor="let item of formatedModels" value="{{item}}" s>{{item}}</mat-option>
  </mat-select>
</div> -->
